import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchCarRent', request, cancelToken)
}

export {get}
